import { HUB_CHANNEL_TYPE_QUERY_PARAM, HUB_TAB_QUERY_PARAM } from "@/dashboard/lib/hub/tab";
import { HubTab } from "@/dashboard/types/hub";

export const DASHBOARD_ROUTES = {
  ANALYTICS: "/dashboard/analytics",
  ANALYTICS_INBOUND: "/dashboard/analytics/inbound",
  ANALYTICS_INBOUND_V2: "/dashboard/analytics/inbound-v2",
  ANALYTICS_CAMPAIGNS: "/dashboard/analytics/campaigns",
  ANALYTICS_EXPLORER: "/dashboard/analytics/explorer",
  CAPACITY: "/dashboard/capacity",
  DASHBOARD: "/dashboard",
  EMERGENCY: "/dashboard/emergency",
  EMERGENCY_CASES: "/dashboard/emergency/cases",
  EMERGENCY_MANAGE: "/dashboard/emergency/manage",
  HUB_ALL: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.ALL}`,
  HUB_FLAGGED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.FLAGGED}`,
  HUB_RESOLVED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.RESOLVED}`,
  HUB_TRANSFERRED: `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${HubTab.TRANSFERRED}`,
  HUB: `/dashboard/hub`,
  MARKETING: "/dashboard/marketing",
  MARKETING_AUDIENCES: "/dashboard/marketing/audiences",
  MARKETING_AUDIENCES_CREATE: "/dashboard/marketing/audiences/create",
  MARKETING_CAMPAIGNS: "/dashboard/marketing/campaigns",
  MARKETING_CAMPAIGNS_CREATE: "/dashboard/marketing/campaigns/create",
  MARKETING_CAMPAIGNS_BETA: "/dashboard/marketing/beta-campaigns",
  MARKETING_CAMPAIGNS_BETA_CREATE: "/dashboard/marketing/beta-campaigns/create",
  MARKETING_CAMPAIGNS_BETA_AUDIENCE_CREATE:
    "/dashboard/marketing/beta-campaigns/create/audience/new",
  MARKETING_CAMPAIGNS_BETA_AUDIENCE_UPLOAD:
    "/dashboard/marketing/beta-campaigns/create/audience/upload-csv",
  MARKETING_CAMPAIGNS_BETA_BUILDER: "/dashboard/marketing/beta-campaigns/create/builder",
  MARKETING_EVENT_TRIGGERS_CREATE: "/dashboard/marketing/event-triggers/create",
  SETTINGS: "/dashboard/settings",
  SETTINGS_TRANSFERS: "/dashboard/settings/transfers",
  SETTINGS_HOURS: "/dashboard/settings/hours",
  SETTINGS_HOLIDAY: "/dashboard/settings/holiday",
  SETTINGS_MEMBERS: "/dashboard/settings/members",
  SETTINGS_CAPACITY_PLANNING: "/dashboard/settings/capacity-planning",
  MEMBERS: "/dashboard/members",
  SIGN_IN: "/sign-in",
  SWITCH_TENANT: "/dashboard/switch-tenant",
} as const;

export const DYNAMIC_DASHBOARD_ROUTES = {
  HUB: (tab: HubTab) => `/dashboard/hub?${HUB_TAB_QUERY_PARAM}=${tab}`,
  HUB_CUSTOMER: (customerId: string, tab?: HubTab, channelType?: "messages" | "calls") => {
    const params = new URLSearchParams();
    if (tab) {
      params.set(HUB_TAB_QUERY_PARAM, tab);
    }
    if (channelType) {
      params.set(HUB_CHANNEL_TYPE_QUERY_PARAM, channelType);
    }

    const queryString = params.toString();
    return `/dashboard/hub/${customerId}${queryString ? `?${queryString}` : ""}`;
  },
  MARKETING_BETA_CAMPAIGN: (campaignId: string) =>
    `/dashboard/marketing/beta-campaigns/${campaignId}`,
} as const;

export const MULTI_TENANT_VIEW_ROUTE_WHITELIST = [DASHBOARD_ROUTES.HUB];
